import { render, staticRenderFns } from "./content-grid.vue?vue&type=template&id=21ef4b41&"
import script from "./content-grid.vue?vue&type=script&lang=js&"
export * from "./content-grid.vue?vue&type=script&lang=js&"
import style0 from "./content-grid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports